import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { AttachFile, Explicit, Note, Print  } from '@material-ui/icons';
import MaterialTable from 'material-table';

import tableIcons from '../../utils/editTableIcons';

import Awb from '../../models/Awb';

import style from './shipmentInventory.module.css';
import awbActionStyle from '../gha/manageOrders/pickupOrderAwbsList/poAwbList.module.css';
import commonStyles from '../common/common.module.css';
import Screening from '../../models/Screening';
import moment from 'moment';
import Forwarder from '../../models/Forwarder';

import { Badge, Grid, Paper } from '@material-ui/core';
import { monthToString } from '../../utils/monthMap';

const iconFontSize = 20;

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      },
    },
    materialIconR4C: {
      color: 'white', 
      margin: '0', 
      cursor: 'pointer', 
      padding: '3px', 
      fontSize: '10px', 
      borderRadius: '3px', 
      backgroundColor: '#000', 
    },
  });

interface AwbInfoGeneralComponentProps {
  classes: any;
  awb: Array<Awb>;
  truckerInfo: any;
  dimensions?: any;
  orderInfo: any;
  forwarder: Forwarder;
  piecesDimmed: number;
  screening: Array<Screening>;
  handleOpenModal: (modalType: string, code: string, number: string, awbVersion: number, orderNumber?: string) => void;
  handleOpenAwbReportModal: (orderNumber: string, orderType: string, code: string, number: string) => void;
  printOrder: (orderNumber: string, code: string, number: string) => void;
};

const awbInfoComponent = (props: AwbInfoGeneralComponentProps) => {

  const { classes } = props;
  
  return (
    <div className= { `${ commonStyles.wrapper }` }>
      <h3 className={ `${ commonStyles.header }` }>
        {props.awb[0].code + '-' + props.awb[0].number}
      </h3>
      <div className={style.inputsWrapper}>
        <MaterialTable
          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
          icons={tableIcons}
          data={props.awb}
          columns={[
            { title: 'Orig', field: 'origin' },

            { title: 'Dest', field: 'destination' },

            { title: 'Pcs', field: 'pieces' },

            {
              title: 'Wgt',
              field: 'weight',
              render: (rowData: Awb) => {
                return `${rowData.weight}K`;
              },
            },
            { title: 'Flight', field: 'Flight',
              render: (rowData: Awb) => {
                return rowData.export_metadata.firstFlightNumber + '/' + moment(rowData.export_metadata.firstFlightDate).format('MMM DD');
              } 
            },
            { title: 'FWD/SHPR', field: 'fwd',
              render: (rowData: Awb) => {
                return props.forwarder.name;
              }
            },

            { title: 'Driver check in',  render: (rowData: any) => {
              const driverCheckIn = props.truckerInfo && props.truckerInfo.driver_checkin_time?  props.truckerInfo.driver_checkin_time.substring(0,2) + ':' + props.truckerInfo.driver_checkin_time.substring(2,4) : '';
              
              return <span>{driverCheckIn}</span>
            }},
          
            { title: 'Driver Check Out', render: (rowData: any) => {
              const deliveredYear = props.truckerInfo && props.truckerInfo.delivered_date ? ( props.truckerInfo.delivered_date.substring(0,4)) : '';
              const deliveredMonth = props.truckerInfo && props.truckerInfo.delivered_date ? (props.truckerInfo.delivered_date.substring(4,6)) : '';
              const deliveredDay = props.truckerInfo && props.truckerInfo.delivered_date ? (props.truckerInfo.delivered_date.substring(6,8)) : '';
              const deliveredTime = props.truckerInfo && props.truckerInfo.delivered_time?  props.truckerInfo.delivered_time.substring(0,2) + ':' + props.truckerInfo.delivered_time.substring(2,4) : '';
              
              return (
              <span>{ props.truckerInfo && props.truckerInfo.delivered_date ? `${deliveredDay} ${monthToString[deliveredMonth]} ${deliveredYear} ${deliveredTime ? deliveredTime : ''}` : ''}</span>
              )
          }},
            {
              title: 'Status',
              render: (rowData: Awb) => {
                if (
                  rowData.status === 'SHIPMENT DELIVERED' ||
                  rowData.status === 'SHIPMENT PARTIALLY DELIVERED' ||
                  rowData.status === 'SHIPMENT REJECTED' ||
                  rowData.status === 'SHIPMENT PARTIALLY REJECTED'
                ) {
                  return (
                    <span>
                      <span>{rowData.status}</span>
                      <span
                        className={style.PoD}
                        onClick={() =>
                          props.handleOpenModal('pod', rowData.code, rowData.number, rowData.version)
                        }>
                        PoD
                      </span>
                    </span>
                  );
                }

                return <span>{rowData.status}</span>;
              },
            },

            {
              title: 'Action',
              headerStyle: { textAlign: 'center' },
              render: (rowData: Awb) => {
                return (
                  <span className={awbActionStyle.awbActionsList}>
                    <Tooltip title='Attach file'>
                      <span>
                        <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachments_count }>
                          <AttachFile className={classes.materialIcon} onClick={() => props.handleOpenModal('attachments', props.awb[0].code, props.awb[0].number, props.awb[0].version)} />
                        </Badge>
                      </span>
                    </Tooltip>
                    {props.truckerInfo.order_type === 'do' && (
                      <Tooltip title='Open R4C checks'>
                        <div><p className={classes.materialIconR4C} onClick={(events) => props.handleOpenModal('rForCheck', rowData.code, rowData.number, rowData.version, props.truckerInfo.number)} >R4C</p></div>
                      </Tooltip>
                    )}
                    <Tooltip title="Open Order Note">
                      <div><p className={classes.materialIconR4C} onClick={(events) => props.handleOpenModal('orderNote', rowData.code, rowData.number, rowData.version, props.truckerInfo.number)}>ODR</p></div>
                    </Tooltip>

                    <Tooltip title="Open Awb Report">
                      <div><p className={classes.materialIconR4C} onClick={(events) => props.handleOpenAwbReportModal(props.truckerInfo.number, 'do', rowData.code, rowData.number)}>XCP</p></div>
                    </Tooltip>

                    {props.truckerInfo.order_type === 'do' && (
                      <Tooltip title='Print'>
                        <Print className={ classes.materialIcon } onClick={() => props.printOrder(props.truckerInfo.number, rowData.code, rowData.number)} />
                      </Tooltip>
                    )}
                  </span>
                );
              },
            },
          ]}
          options={{
            search: false,
            paging: false,
            showTitle: false,
            actionsColumnIndex: -1,
            toolbar: false,
            sorting: false,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
              },
          }}
        />
      </div>

      <div className= { `${ commonStyles.wrapper } ${ style.insideWrapper }` }>
        <h3 className={ style.insideHeader }>Truckers Record</h3>
        <div className={ style.info }>
        <Grid container>
          <Grid item lg={ 2 } md={ 3 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
            <span className={ style.tag }>Name:</span>{' '}
            <span className={ style.data }>{ props.truckerInfo.driver_name }</span>
            </Grid>
          <Grid item lg={ 2 } md={ 3 } sm={ 4 } xs={ 6 } className={ style.insideData } >
            <span className={ style.tag }>Company:</span>{' '}
            <span className={ style.data }>
              { props.truckerInfo.delivery_company_name }
            </span>
          </Grid>
          <Grid item lg={ 2 } md={ 3 } sm={ 4 } xs={ 6 } className={ style.insideData } >
            <span className={ style.tag }>Type of ID:</span>{' '}
            <span className={ style.data }>{ props.truckerInfo.driver_id_type }</span>
          </Grid>
          <Grid item lg={ 2 } md={ 3 } sm={ 4 } xs={ 6 } className={ style.insideData } >
            <span className={ style.tag }>Second ID:</span>{' '}
            <span className={ style.data }>N/A</span>
          </Grid>
          <Grid item lg={ 2 } md={ 3 } sm={ 4 } xs={ 6 } className={ style.insideData } >
            <span className={ style.tag }>Matching Photo:</span>{' '}
            <span className={ style.data }>
              { props.truckerInfo.matching_photo ? 'Yes' : 'No' }
            </span>
          </Grid>
          <Grid item lg={ 1 } md={ 3 } sm={ 4 } xs={ 6 } className={ style.insideData } >
            <span className={ style.tag }>In:</span>{' '}
            <span className={ style.data }>{ props.truckerInfo.driver_checkin_time }</span>
          </Grid>
          <Grid item lg={ 1 } md={ 3 } sm={ 4 } xs={ 6 } className={ style.insideData } >
            <span className={ style.tag }>Out:</span>{' '}
            <span className={ style.data }>{ props.truckerInfo.delivered_time }</span>
          </Grid>
        </Grid>
        </div>
      </div>
      { props.truckerInfo.order_type === 'do' && (
        <div className= { `${ commonStyles.wrapper } ${ style.insideWrapper }` }>
         <h3 className={ style.insideHeader }>Weight & Dims</h3>
        <div className={ style.info }>
          <Grid container>
            <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
              <span className={ style.tag }>Scale Weight:</span>{' '}
              <span className={ style.data }>{ props.orderInfo.actual_scale_weight }</span>
            </Grid>
            <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
              <span className={ style.tag }>Chargeable Weight:</span>{' '}
              <span className={ style.data }>{ Number(props.orderInfo.cwt).toFixed(1).toString() + 'K' }</span>
            </Grid>
            <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
              <span className={ style.tag }>Total Pieces Dimmed:</span>{' '}
              <span className={ style.data }>{ props.piecesDimmed }</span>
            </Grid>
          </Grid>
        </div>

          <div className={ style.info }>
            {props.orderInfo.cwt_data.data.map((cwt: any) => (
              <span className={ style.dims }>
                { cwt.length }/{ cwt.width }/{ cwt.height }/{ cwt.totalWeight }-{ cwt.pieces }
              </span>
            ))}
          </div>
        </div>
      )}

      {props.truckerInfo.order_type === 'do' && (
        <div className= { `${ commonStyles.wrapper } ${ style.insideWrapper }` }>
          <h3 className={ style.insideHeader }>Screening Details</h3>
          { props.screening.map((screening: Screening) => (
            <div className={ style.info }>
              <Grid container>
                <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                        <span className={ style.tag }>Pcs:</span>{' '}
                        <span className={ style.data }>{ screening.pieces }</span>
                  </Grid>
                  <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                        <span className={ style.tag }>Measure Applied:</span>{' '}
                        <span className={ [ style.data, style.measure ].join(" ") }>{ screening.measure_applied }</span>
                  </Grid>
                  <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                      <span className={ style.tag }>Details:</span>{' '}
                      <span className={ [ style.data, style.screeningDetailsTag ].join(" ") }>{ screening.screening_details }</span>
                  </Grid>
                  <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                      <span className={ style.tag }>Weight/Remarks:</span>{' '}
                      <span className={ [ style.data, style.remarks ].join(" ") }>{ screening.details }</span>
                  </Grid>
                  <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                      <span className={ style.tag }>Flight:</span>{' '}
                      <span className={ style.data }>{ screening.flight }</span>
                  </Grid>
                  <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                      <span className={ style.tag }>Screened By:</span>{' '}
                      <span className={ style.data }>{ screening.screened_by }</span>
                  </Grid>
                  <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                      <span className={ style.tag }>Date/Time:</span>{' '}
                      <span className={ style.data }>{ screening.date_time }</span>
                  </Grid>
                  <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                      <span className={ style.tag }>Alarm:</span>{' '}
                      <span className={ style.data }>{ screening.alarm ? 'Yes' : 'No' }</span>
                  </Grid>
                  { screening.alarm && <Grid item md={ 4 } sm={ 4 } xs={ 6 }  className={ style.insideData }>
                      <span className={ style.tag }>Alarm Resolution:</span>{' '}
                      <span className={ style.data }>{ screening.alarm ? screening.alarm_resolution : '-' }</span>
                  </Grid> }
              </Grid> 
            </div>
          ))}
        </div>
      )} 
    </div>
  );
};

export default withStyles(styles)(awbInfoComponent);